<ion-app>
  <ion-split-pane [when]="isDesktop && desktopSidebarOpen" contentId="main-content" class="admin-shell-split-pane">
    @if (userData) {
      <ion-menu contentId="main-content" type="overlay" side="start" class="admin-shell-menu">
        <ion-content class="admin-shell-menu__content" [scrollY]="false">
          <div class="admin-sidebar">
            <div class="admin-sidebar__header">
              <ion-button fill="clear" class="admin-sidebar__toggle" aria-label="Close navigation" (click)="toggleNavigation()">
                <ion-icon name="menu-outline" slot="icon-only"></ion-icon>
              </ion-button>
              <a class="admin-sidebar__brand" routerLink="/dashboard">
                <div class="admin-sidebar__brand-content">
                  <div class="admin-sidebar__brand-mark">
                    <img src="/assets/icon/logo.png" alt="Doskai" />
                  </div>
                  <div class="admin-sidebar__brand-copy">
                    <strong>Doskai Admin</strong>
                    <span>Control Center</span>
                  </div>
                </div>
              </a>

              <div class="admin-sidebar__meta">
                <span class="admin-sidebar__pill">{{ userRole || "Admin" }}</span>
                <span class="admin-sidebar__pill admin-sidebar__pill--ghost">v{{ version }} · build {{ buildCode }}</span>
              </div>

              <ion-searchbar
                class="admin-sidebar__search"
                mode="md"
                debounce="150"
                placeholder="Search admin pages"
                (ionInput)="onNavSearch($event)"
              ></ion-searchbar>
            </div>

            <div class="admin-sidebar__body">
              <ion-list lines="none" mode="md" class="admin-sidebar__nav">
                @for (section of filteredNavSections; track section.section) {
                  <ion-item
                    button
                    detail="false"
                    lines="none"
                    class="section-header"
                    [class.section-expanded]="isSectionExpanded(section.section)"
                    [class.section-active]="isSectionActive(section)"
                    (click)="toggleSection(section.section)"
                  >
                    <ion-icon slot="start" [name]="section.icon"></ion-icon>
                    <ion-label>
                      <strong>{{ section.section }}</strong>
                    </ion-label>
                    @if (getNavCountBadge(section.countBadgeKey); as sectionCount) {
                      <ion-badge slot="end" color="danger" class="nav-count-badge">
                        {{ sectionCount }}
                      </ion-badge>
                    }
                    <ion-icon slot="end" [name]="isSectionExpanded(section.section) ? 'chevron-down' : 'chevron-forward'"></ion-icon>
                  </ion-item>

                  <div class="section-pages" [class.section-pages-expanded]="isSectionExpanded(section.section)">
                    @for (page of section.pages; track page.url) {
                      @if (canAccessPage(page)) {
                        @if (page.isExternal && page.externalUrl) {
                          <a class="page-link" href="{{ page.externalUrl }}" target="_blank" rel="noopener noreferrer">
                            <ion-menu-toggle auto-hide="false">
                              <ion-item routerDirection="root" lines="none" detail="false" class="page-item" tappable>
                                <ion-icon slot="start" [name]="page.icon" size="small"></ion-icon>
                                <ion-label>{{ page.title }}</ion-label>
                                @if (page.badge) {
                                  <ion-badge slot="end" [color]="getBadgeColor(page.badge)">
                                    {{ page.badge }}
                                  </ion-badge>
                                }
                                @if (getNavCountBadge(page.countBadgeKey); as pageCount) {
                                  <ion-badge slot="end" color="danger" class="nav-count-badge">
                                    {{ pageCount }}
                                  </ion-badge>
                                }
                              </ion-item>
                            </ion-menu-toggle>
                          </a>
                        } @else if (!page.isExternal) {
                          <ion-menu-toggle auto-hide="false">
                            <ion-item
                              class="page-link page-item"
                              [routerLink]="[page.url]"
                              [queryParams]="sidebarQueryParams(page)"
                              routerLinkActive="menu-item-active"
                              [routerLinkActiveOptions]="{ exact: false }"
                              routerDirection="root"
                              lines="none"
                              detail="false"
                              tappable
                            >
                              <ion-icon slot="start" [name]="page.icon" size="small"></ion-icon>
                              <ion-label>{{ page.title }}</ion-label>
                              @if (page.badge) {
                                <ion-badge slot="end" [color]="getBadgeColor(page.badge)">
                                  {{ page.badge }}
                                </ion-badge>
                              }
                              @if (getNavCountBadge(page.countBadgeKey); as pageCount) {
                                <ion-badge slot="end" color="danger" class="nav-count-badge">
                                  {{ pageCount }}
                                </ion-badge>
                              }
                            </ion-item>
                          </ion-menu-toggle>
                        }
                      }
                    }
                  </div>
                } @empty {
                  <div class="admin-sidebar__empty">
                    <strong>No matching pages</strong>
                    <span>Try users, payouts, training, support, or project board.</span>
                  </div>
                }
              </ion-list>

              <div class="admin-sidebar__footer">
                <span>Doskai Admin Control Center</span>
                <small>&copy; {{ year }} Doskai</small>
              </div>
            </div>
          </div>
        </ion-content>
      </ion-menu>
    }

    <div id="main-content" class="admin-shell-main">
      <app-header
        [userData]="userData"
        [navigationOpen]="isDesktop && desktopSidebarOpen"
        (navigationToggle)="toggleNavigation()"
      ></app-header>
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>

  <!-- Firebase Auth Phone reCAPTCHA container (must stay mounted) -->
  <div id="recaptcha-container" style="position: absolute; left: -9999px; top: -9999px"></div>
</ion-app>
